module.exports = __webpack_public_path__ + "static/media/校园多楼宇综合供热1.4f3808bf.jpg";